import { render, staticRenderFns } from "./EmailViewComponent.vue?vue&type=template&id=73c1ad78"
import script from "./EmailViewComponent.vue?vue&type=script&lang=js"
export * from "./EmailViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports